import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';

import '../styles/discoveryconversation.css';
import MessageList from '../discovery/MessageList';
import MessageInput from '../discovery/MessageInput';
import { useChatData } from './ChatData';

/**
 * "Chat with Dooglie": the history, the prompt buttons and the composer,
 * drawn from `useChatData()`. What is being typed lives here; everything else
 * comes from whoever provides the `ChatData`.
 */
const ChatView: React.FC = () => {
  const chat = useChatData();
  const [input, setInput] = useState('');
  const [placeholder, setPlaceholder] = useState('Answer your doogle question here');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  }, [input]);

  const handleSend = () => {
    if (chat.upload.uploadingFiles) return;
    if (input.trim() === '' && chat.upload.fileIds.length === 0) return;
    const text = input;
    setInput('');
    void chat.send(text);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'white',
        overflow: 'hidden',
      }}
    >
      <Box className="dg-chat-header">
        <Typography className="dg-chat-header-title">Chat with Dooglie</Typography>
      </Box>

      <MessageList
        messages={chat.messages}
        loading={chat.loading}
        initialMessagesLoading={chat.initialLoading}
        renderMarkdown={chat.renderMarkdown}
      />

      <MessageInput
        input={input}
        placeholder={placeholder}
        textareaRef={textareaRef}
        loading={chat.loading}
        discoveryButtons={chat.buttons}
        files={chat.upload}
        onValueChange={setInput}
        onFocus={() => setPlaceholder('')}
        onBlur={() => {
          if (input === '') setPlaceholder('Type here...');
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
          }
        }}
        onSend={handleSend}
        onButtonClick={(intent) => void chat.send('', intent)}
      />
    </Box>
  );
};

export default ChatView;
